<app-enfaf-modal
  [title]="'Cursos del estudiante: ' + fullname"
  (onConfirm)="closeModal()"
  [showCancelButton]="false"
  [buttonConfirmText]="'Cerrar'"
  [svgIcon]="'book'"
>
  @if (!courses.length) {
    <p class="no-current">No tiene cursos disponibles</p>
  } @else {
    <div class="courses">
      @if (someCourseHasProgress) {
        <div class="download">
          <button mat-flat-button color="secondary" (click)="downloadStudentCoursesProgress()" [disabled]="isDownloadingProgress">
            @if (!isDownloadingProgress) {
              <span>Descargar CSV con los progresos del estudiante</span>
            } @else {
              <mat-spinner class="white-spinner"> </mat-spinner>
            }
          </button>
        </div>
      }
      @for (course of courses; track course.courseId) {
        <div class="course">
          <div class="course-header">
            {{ course.name }}
            @if (course.diploma || course.diplomaTemplateId) {
              <button
                mat-icon-button
                class="diploma-download-btn"
                [disabled]="downloadingDiplomaCourseId === course.courseId"
                (click)="downloadCourseDiploma(course.courseId)"
                matTooltip="Descargar diploma"
              >
                @if (downloadingDiplomaCourseId !== course.courseId) {
                  <mat-icon>workspace_premium</mat-icon>
                } @else {
                  <mat-spinner diameter="20"></mat-spinner>
                }
              </button>
            }
          </div>
          <div class="course-content">
            @if (!course.lastCompletedSection && !course.lastCompletedModule && !course.lastCompletedClass) {
              <span class="no-progress">No tiene progreso disponible</span>
            }
            @if (course.lastCompletedSection && course.lastCompletedModule && course.lastCompletedClass) {
              <div class="progress">
                <p> La última clase completada es: </p>
                <ul>
                  <li>
                    Asignatura
                    {{
                      course.lastCompletedSection.number !== null && course.lastCompletedSection.number !== undefined
                        ? course.lastCompletedSection.number + 1
                        : 0
                    }}: {{ course.lastCompletedSection.name }}
                  </li>
                  <li>
                    Módulo
                    {{
                      course.lastCompletedModule.number !== null && course.lastCompletedModule.number !== undefined
                        ? course.lastCompletedModule.number + 1
                        : 0
                    }}: {{ course.lastCompletedModule.name }}
                  </li>
                  <li>
                    Clase
                    {{
                      course.lastCompletedClass.number !== null && course.lastCompletedClass.number !== undefined
                        ? course.lastCompletedClass.number + 1
                        : 0
                    }}: {{ course.lastCompletedClass.name }}
                  </li>
                </ul>
              </div>
            }

            @if (course.generateEnrollmentOrder) {
              <div class="export-enrollment-order">
                <button mat-flat-button color="secondary" (click)="exportCourseEnrollmentOrder(course.courseId)" [disabled]="isDownloadingProgress">
                  @if (!isDownloadingProgress) {
                    <span>Orden de matrícula</span>
                  } @else {
                    <mat-spinner class="white-spinner"> </mat-spinner>
                  }
                </button>
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
</app-enfaf-modal>
